import { useMutation } from "@tanstack/react-query";
import ApiClient from "../../../api/ApiClient";
import { Option } from "../data/Option";
import { AxiosError } from "axios";

type CategoryOptionProps = {
    name: string
    order: number,
    categoryId: number,
}

async function post(data: CategoryOptionProps): Promise<Option> {
    try {
        const response = await ApiClient({ url: `categories/${data.categoryId}/options`, method: "POST", data: { name: data.name, order: data.order } });
        if (response.status === 201) {
            return response.data;
        }
        throw new Error(response.data);
    } catch (error) {
        throw new Error(error instanceof AxiosError ? error.response?.data?.error : "An unexpected error occurred");
    }
}

export function usePostOptionMutation(onSuccess: (data: Option) => void, onError: (error: Error) => void) {
    return useMutation<Option, Error, CategoryOptionProps>({
        mutationKey: ["post-option"],
        mutationFn: post,
        onSuccess: onSuccess,
        onError: onError
    });
}